import Error from './views/Error.vue'
import Front from './views/Layout.vue'
import Backk from './views/back/Layout.vue'

export default {
  mode: 'hash',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      component: Front,
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('./views/Home.vue')
        },
        {
          path: 'about',
          name: 'about',
          component: () => import('./views/About.vue')
        },
        {
          path: 'confirm/:token',
          name: 'confirm', //props: r => ({value: r.query}), 
          component: () => import('./views/Email.vue')
        }
      ]
    },
    {
      path: '/ross',
      component: Backk,
      meta: {auth: true},
      children: [
        {
          path: '',
          name: 'ross',
          component: () => import('./views/back/Home.vue')
        },
        {
          path: 'profile',
          name: 'profile',
          component: () => import('./views/back/Profile.vue')
        },
        {
          path: 'tiers',
          name: 'tiers',
          component: () => import('./views/back/Tiers.vue')
        },
        {
          path: 'depot',
          name: 'depot',
          component: () => import('./views/back/Depot.vue')
        },
        {
          path: 'retrait',
          name: 'retrait',
          component: () => import('./views/back/Retrait.vue')
        },
        {
          path: 'transfer',
          name: 'transfer',
          component: () => import('./views/back/Transfer.vue')
        },
        {
          path: 'souscri',
          name: 'souscri',
          component: () => import('./views/back/Souscri.vue')
        },
        {
          path: 'bond',
          name: 'bond',
          component: () => import('./views/back/Bond.vue')
        },
        {
          path: 'ordre',
          name: 'ordre',
          component: () => import('./views/back/Ordre.vue')
        },
        {
          path: 'rate',
          name: 'rate',
          component: () => import('./views/back/Rate.vue')
        },
        {
          path: 'compte',
          name: 'wallet',
          component: () => import('./views/back/Wallet.vue')
        },
        {
          path: 'service',
          name: 'service',
          component: () => import('./views/About.vue')
        }
      ]
    },
    { path: '*', component: Error }  
  ]
}
